import { LOGIN_SUCCESS, LOGIN_ERROR, DISMISS_MESSAGE, UPDATE_USER_INFO, USER_DATA_UPDATE, SET_IS_PBS_AUTHORITY_REQUIRED, UPDATE_EBS_NUMBER, SAVE_ATTACHMENT, DELETE_ATTACHMENT, SAVE_DRUG_INFO, DELETE_DRUG_INFO, REMOVE_ASSESSMENT_DATA, UPDATE_MIMS_EULA_REVISION, UPDATE_MIMS_TERMS_REVISION } from "../constants/auth";

const initialState = {
  loading: false,
  success: false,
  error: false,
  message: "",
  isLoggedIn: false,
  user: null,
  isPBSAuthorityRequired: false,
  data: null, // this is for prescription
  attachments: [], // instant switch prescription attachments
  prescriptionDrugs: [], // instant switch prescription drugs info
  mimsEulaRevision: null, // MIMS EULA accepted revision date
  mimsTermsRevision: null, // MIMS Terms accepted revision date
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LOGIN_SUCCESS:
      return {
        ...state,
        success: false,
        error: false,
        isLoggedIn: true,
        loading: false,
        message: "",
        user: action.payload
      };
    case LOGIN_ERROR:
      return {
        ...state,
        success: false,
        error: true,
        isLoggedIn: false,
        loading: false,
        message: action.payload
      };
    case DISMISS_MESSAGE:
      return {
        ...state,
        success: false,
        error: false,
        message: ""
      };
    case UPDATE_USER_INFO:
      return {
        ...state,
        success: false,
        error: false,
        isLoggedIn: true,
        loading: false,
        message: "",
        user: action.payload
      }
    case SET_IS_PBS_AUTHORITY_REQUIRED:
      return {
        ...state,
        isPBSAuthorityRequired: action.payload
      };
    case UPDATE_EBS_NUMBER:
      return {
        ...state,
        data: {
          ...state.data,
          ebsnumber: action.payload
        }
      };
    case SAVE_ATTACHMENT:
      return {
        ...state,
        attachments: [...state.attachments, action.payload]
      };
    case DELETE_ATTACHMENT:
      console.log("Delete attachment: ", action.payload);
      return {
        ...state,
        attachments: state.attachments.filter(
          item => item.url !== action.payload.url
        )
      };
    case SAVE_DRUG_INFO:
      return {
        ...state,
        prescriptionDrugs: action.payload
      };
    case DELETE_DRUG_INFO:
      console.log("Now saving new drug info in redux: ", action.payload);
      return {
        ...state,
        prescriptionDrugs: action.payload
      };
    case REMOVE_ASSESSMENT_DATA:
      return {
        ...state,
        prescriptionDrugs: [],
        attachments: [],
        data: null,
        isPBSAuthorityRequired: false
      };
    case UPDATE_MIMS_EULA_REVISION:
      return {
        ...state,
        mimsEulaRevision: action.payload
      };
    case UPDATE_MIMS_TERMS_REVISION:
      return {
        ...state,
        mimsTermsRevision: action.payload
      };
    default:
      return state;
  }
}
